import RequestManager from "../../API";
import api from "../../utils/api";
import {
  storeProducts,
  storeProductCount,
  storeProduct,
  storeRelProducts,
  storeCartDetails,
  CartOrderData,
  storeSearchData,
  storeSecondaryImage,
  storeSearchCount,
  setRSDAvailable,
} from "./productsActions";
import { ProductsMdl } from "../../Modal/Products";
import { setFilterLoading, setLoading } from "../common/commonActions";
import axios from "axios";
import { Dispatch } from "react";

let cancelToken: any;

export const getproducts =
  (query?: string, loadMore?: boolean, setMoreData?: any) =>
  async (dispatch: any, getState: any) => {
    try {
      if (cancelToken) {
        cancelToken.cancel();
      }
      cancelToken = axios.CancelToken.source();
      dispatch(setFilterLoading(true));
      dispatch(setLoading(true));
      const response: any = await RequestManager.getRequest(
        dispatch,
        api.GET_PRODUCTS,
        "",
        query,
        { cancelToken: cancelToken.token }
      );
      if (response) {
        const productsData: ProductsMdl[] = response?.data ?? [];
        dispatch(setRSDAvailable(response.RSDAvailable));
        dispatch(storeProducts(productsData, loadMore));
        dispatch(storeProductCount(response?.count ?? 0));
        dispatch(setLoading(false));
        dispatch(setFilterLoading(false));

        return response;
      } else {
        dispatch(storeProducts([], false));
      }
      dispatch(setLoading(false));
      setMoreData(false);
    } catch (error: any) {
      // if (axios.isCancel(error)) {
      //   console.log("Request canceled:", error?.message);
      // } else {
      //   console.log("Error:", error?.message);
      // }
    }
  };

  export const getExportproducts =
  (query?: string,setIsExport?:any, loadMore?: boolean, setMoreData?: any) =>
  async (dispatch: any, getState: any) => {
    try {
      if (cancelToken) {
        cancelToken.cancel();
      }
      cancelToken = axios.CancelToken.source();
      // dispatch(setFilterLoading(true));
      // dispatch(setLoading(true));
      const response: any = await RequestManager.getRequest(
        dispatch,
        api.GET_PRODUCTS_EXPORT,
        "",
        query,
        { cancelToken: cancelToken.token }
      );
      if (response) {
        // dispatch(setFilterLoading(false));
        // const productsData: ProductsMdl[] = response?.data ?? [];
        // dispatch(setRSDAvailable(response.RSDAvailable));
        // dispatch(storeProducts(productsData, loadMore));
        // dispatch(storeProductCount(response?.count ?? 0));
        // dispatch(setLoading(false));
        setIsExport(false);
        return response;
      } else {
        setIsExport(false);
        dispatch(storeProducts([], false));
      }
      dispatch(setLoading(false));
      setMoreData(false);
    } catch (error: any) {
      setIsExport(false);
      // if (axios.isCancel(error)) {
      //   console.log("Request canceled:", error?.message);
      // } else {
      //   console.log("Error:", error?.message);
      // }
    }
  };
export const getHomePageProducts =
  (query?: string, loadMore?: boolean, setMoreData?: any) =>
  async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_HOMEPAGE_PRODUCTS,
      "",
      query
    );
    if (response) {
      const productsData: ProductsMdl[] = response?.data;
      dispatch(setLoading(false));
      return productsData;
      // dispatch(storeProducts(productsData, loadMore));
      // dispatch(storeProductCount(response.count));
    } else {
      dispatch(setLoading(false));
      dispatch(storeProducts([], false));
    }

    setMoreData(false);
  };
export const getproduct =
  (query?: string) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_PRODUCTS,
      "",
      query
    );
    if (response) {
      const productData: ProductsMdl[] = response?.data
        ? response.data[0]
        : response.data;
      dispatch(storeProduct(productData));
      dispatch(setLoading(false));
      return productData;
    } else {
      dispatch(storeProduct([]));
      dispatch(setLoading(false));
    }

    dispatch(setLoading(false));
  };
export const getRelproducts =
  (query?: string) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_PRODUCTS,
      "",
      query
    );
    if (response) {
      const productData: ProductsMdl[] = response.data;
      dispatch(storeRelProducts(productData));
      dispatch(setLoading(false));
      return productData;
    } else {
      dispatch(storeRelProducts([]));
    }
  };
// addToCartOrder

export const addToCartOrder =
  (query?: any) => async (dispatch: any, getState: any) => {
    dispatch(setLoading(true));
    try {
      const response: any = await RequestManager.postRequest(
        dispatch,
        api.ADD_TO_CART_ORDERS,
        "",
        query
      );
      if (response) {
        dispatch(setLoading(false));
        const productData: any = response;
        return productData;
      }
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

//CartDetailShow
export const CartDetailShow =
  (query?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.CART_DATA_SHOW,
      "",
      query
    );
    if (response) {
      const cartData: any = response;
      dispatch(storeCartDetails(cartData?.data?.[0] ?? []));
      dispatch(setLoading(false));
      return response;
    } else {
      dispatch(setLoading(false));
    }
  };
export const DeleteCart =
  (query?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.deleteRequest(
      dispatch,
      api.DELETE_CART,
      query,
      ""
    );
    if (response) {
      const deleteCart: any = response;
      return deleteCart;
    } else {
    }
  };

export const CartInfo =
  (query1?: any, query2?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.putRequest(
      dispatch,
      api.CART_INFO,
      query1,
      ""
    );
    if (response) {
      const deleteCart: any = response;
      return deleteCart;
    } else {
    }
  };
export const ProceedToCheckOut =
  (query1?: any, query2?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.postRequest(
      dispatch,
      api.ORDER_INFO,
      "",
      query1
    );

    if (response) {
      const order: any = response;

      dispatch(CartOrderData(order));
      return order;
    } else {
    }

    dispatch(setLoading(false));
  };
export const counterCount =
  (query?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.putRequest(
      dispatch,
      api.CART_INFO,
      query,
      ""
    );
    if (response) {
      const counterCount: any = response;
      return counterCount;
    } else {
    }
  };

export const updateCartDetail =
  (query?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.deleteRequest(
      dispatch,
      api.DELETE_CART,
      query,
      ""
    );
    if (response) {
      const deleteCart: any = response;
      return deleteCart;
    } else {
    }
  };

//getBanner
export const getBanner =
  (query?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_BANNER,
      "",
      query
    );
    if (response) {
      const bannerData: any = response;
      return bannerData;
    } else {
    }
    dispatch(setLoading(false));
  };
// releasesFilter
export const releasesFilter =
  (query?: any, query2?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.RELEASES_FILTER,
      "",
      query,
      query2
    );
    if (response) {
      const releasesFilterData: any = response?.data;
      dispatch(storeProducts(response?.data));
      dispatch(storeProductCount(response?.count));
    } else {
      dispatch(storeProducts([], false));
    }
    dispatch(setLoading(false));
  };
//SearchData

export const SearchData =
  (query?: string, loadMore?: boolean, setMoreData?: any) =>
  async (dispatch: any, getState: any) => {
    if (cancelToken) {
      cancelToken.cancel();
    }
    cancelToken = axios.CancelToken.source();
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_SEARCH_PRODUCT,
      "",
      query,
      { cancelToken: cancelToken.token }
    );
    if (response) {
      const releasesFilterData: any = response?.data ? response?.data : [];
      dispatch(storeSearchData(releasesFilterData, loadMore));
      dispatch(storeSearchCount(response?.count));

      dispatch(setLoading(false));
      return releasesFilterData;
    }
    setMoreData(false);
    dispatch(setLoading(false));
  };

  export const exportSearchData =
  (query?: string, loadMore?: boolean, setMoreData?: any) =>
  async (dispatch: any, getState: any) => {
    if (cancelToken) {
      cancelToken.cancel();
    }
    cancelToken = axios.CancelToken.source();
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_SEARCH_PRODUCT,
      "",
      query,
      { cancelToken: cancelToken.token }
    );
    if (response) {
      const releasesFilterData: any = response?.data ? response?.data : [];

      return releasesFilterData;
    }
  };
//getImagesRelDescription
export const getSecondryImages =
  (query?: any, query2?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_SECONDRY_IMAGES,
      "",
      query,
      query2
    );
    if (response) {
      const responseOfSecondaryImage: any = response?.data;
      dispatch(storeSecondaryImage(responseOfSecondaryImage));
      return responseOfSecondaryImage;
    } else {
      dispatch(storeSecondaryImage([]));
    }
    dispatch(setLoading(false));
  };

// GET_PRODUCT_TRACKS

export const getProductTracks =
  (query?: any, query2?: any) => async (dispatch: any, getState: any) => {
    const response: any = await RequestManager.getRequest(
      dispatch,
      api.GET_PRODUCT_TRACKS,
      "",
      query,
      query2
    );
    if (response) {
      return response;
    } else {
      dispatch(storeSecondaryImage([]));
    }
    dispatch(setLoading(false));
  };



  export const downloadReleaseDescription =
  (query?: string,setIsDownload?:any) =>
  async (dispatch: any, getState: any) => {
    try {
      // dispatch(setLoading(true));
      setIsDownload(true);
      if (cancelToken) {
        cancelToken.cancel();
      }
      cancelToken = axios.CancelToken.source();
      // Send GET request to the API with cancel token
      const response:any = await RequestManager.getRequest(
        dispatch,
        api.DOWNLOAD_RELEASE,
        "",
        query,
        { cancelToken: cancelToken.token, responseType: 'blob' } // Ensure response is in blob format
      );

      // Check if response is valid (ZIP file expected)
      if (response) {
        // Create a Blob from the binary data
        const fileBlob = new Blob([response], { type: 'application/zip' });

        // Create an object URL for the Blob
        const downloadUrl = URL.createObjectURL(fileBlob);

        // Create a temporary anchor tag (<a>) to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = 'download.zip'; // Set the name for the downloaded file
        document.body.appendChild(link);  // Append the link to the DOM
        link.click();  // Trigger a click on the link to start the download
        document.body.removeChild(link);  // Clean up by removing the link

        // Revoke the object URL to free up memory
        URL.revokeObjectURL(downloadUrl);
        // dispatch(setLoading(false));
        setIsDownload(false);
      } else {
        console.error("Error: No valid ZIP file in the response");
        // dispatch(setLoading(false));
        setIsDownload(false);
      }

    } catch (error: any) {
      dispatch(setLoading(false));
      setIsDownload(false)
      console.error('Download failed', error);
    }
  };